import Button from '@/common/components/Button'
import { ApproveSupplyAuthorizationModal } from '@/features/supplyAuthorizations/components/ApproveBillingSupplyAuthorizationModal'
import { RejectBillingSupplyAuthorizationModal } from '@/features/supplyAuthorizations/components/RejectBillingSupplyAuthorizationModal'
import { BillingSupplyAuthorizationStatus } from '@/features/supplyAuthorizations/types/billingSupplyAuthorization.type'

interface BillingSupplyAuthorizationReviewButtonsProps {
  status?: BillingSupplyAuthorizationStatus
}

export const BillingSupplyAuthorizationReviewButtons = ({ status }: BillingSupplyAuthorizationReviewButtonsProps) => {
  return (
    <div className="flex gap-2">
      {status === 'rejected' ? (
        <Button type="button" className="w-[10.25rem]" variant="error" disabled>
          Declinado
        </Button>
      ) : (
        <RejectBillingSupplyAuthorizationModal disabled={status !== 'pending'} />
      )}

      {status === 'approved' ? (
        <Button type="button" className="w-[10.25rem] bg-success-disabled disabled:hover:bg-success-disabled" disabled>
          Aprovado
        </Button>
      ) : (
        <ApproveSupplyAuthorizationModal disabled={status !== 'pending'} />
      )}
    </div>
  )
}
